import React from 'react';
import { Card, Flex, Progress, StatusChip, Text } from '@/components/ui';
import { ImportProgressSection } from './ImportProgressSection';
import type { MappingData } from '../../utils/transformMappingData';

interface ImportProgressCardProps {
  mappingData: MappingData;
}

export const ImportProgressCard: React.FC<ImportProgressCardProps> = ({
  mappingData,
}) => {
  return (
    <Card>
      <Flex direction="column" gap="3">
        <Flex justify="between" align="center">
          <Text size="4" weight="medium">
            Import Progress
          </Text>
          {mappingData.status === 'imported' ? (
            <Text size="3" color="success">
              100%
            </Text>
          ) : mappingData.status === 'invalid_for_import' ? (
            <Text size="3" color="error">
              0%
            </Text>
          ) : mappingData.progress_percentage !== undefined ? (
            <Text size="3" color="gray">
              {mappingData.progress_percentage}%
            </Text>
          ) : mappingData.status === 'created' ? (
            <StatusChip
              entityType="import_mapping"
              status="created"
              variant="soft"
              label="Ready to process"
            />
          ) : null}
        </Flex>

        {mappingData.status === 'created' ? (
          <>
            <Progress value={0} max={100} color="info" size="small" />
            <Text size="2xsmall" color="gray" align="center">
              Mapping created successfully. Awaiting validation...
            </Text>
          </>
        ) : (
          <ImportProgressSection
            status={mappingData.status}
            recordsProcessed={mappingData.records_processed}
            totalRecords={mappingData.total_records}
            progressPercentage={
              mappingData.status === 'imported'
                ? 100
                : mappingData.status === 'valid_for_import'
                  ? (mappingData.progress_percentage ?? 50)
                  : mappingData.status === 'invalid_for_import'
                    ? (mappingData.progress_percentage ?? 2)
                    : mappingData.progress_percentage
            }
            successCount={mappingData.success_count}
            errorCount={mappingData.error_count}
            errorMessage={mappingData.error_message}
            showSpinner={mappingData.status === 'valid_for_import'}
          />
        )}
      </Flex>
    </Card>
  );
};

